import React from "react";
import style from './DemolitionServices.module.scss';

const DemolitionServicesOptions = (props) => {
  const { optionsList } = props;
  const { details, isDrawingsExporting, updateDetails, itemDetails } = props;

  const updateFieldDetails = (id, value, type) => {
    const obj = {
      id: id, 
      details: {
        ...itemDetails?.[id]?.details,
        [type]: value
      }
    }
    updateDetails({ id: details.id, value: obj })
  }

  return (
    <div className={style.option_view}>
      {!isDrawingsExporting ? <input value={itemDetails?.[details?.id]?.details?.input} onChange={(v) => updateFieldDetails(details.id, v.target.value, 'input' )} maxLength={6} /> : <span>{itemDetails?.[details?.id]?.details?.input || ''}</span>}
      {!isDrawingsExporting ? <select className={style.edit_select_options} onChange={(v) => updateFieldDetails(details.id, v.target.value, 'option' )}>
        <option value='' selected>No</option>
        {
          optionsList?.map((e: any) => <option value={e} selected={itemDetails?.[details?.id]?.details?.option === e}>{e}</option>)
        }
      </select> : <span>{itemDetails?.[details?.id]?.details?.option || 'No'}</span>
      }
    </div>
  )
}

export default DemolitionServicesOptions;